module.exports = __webpack_public_path__ + "static/media/no_purchases.1a86f47e.png";